import React, { useEffect, useState, useContext } from 'react';
import { ProductModalContext } from '../../ProductModalContext';

import { Button } from 'web-store-modules/packages/web-store-ui-library'

import { BuyNowOnce, BuyNowClicked, AddToWishlistClicked, AddToWishlistValue, AddToWishlistTotalItems } from '../../../../../../utils/Analytics';
// import ProductModalDropdown from './dropdown-button/ProductModalDropdown.jsx';
// import ProductModalCartOverlay from './ProductModalCartOverlay';
import { AddToCartContext } from '../../../../add-to-cart/AddToCartContext';
import { storeTrans } from '../../../../../../utils/StoreTranslator';
import { constructUrl } from '../../../../../../utils/UrlConstructor';

const ProductModalButtons = ({ sku, title, price, downsizedThumbnail, buttonFontStyle, addToCartFontStyle, buyNowFontStyle, productButtonCopy, addToCartCopy, url, cartUrl, setShowingAddToCartPrompt, addToCartEnabled, storeId }) => {
    const { colors, buttonBorderRadius, buttonBorderWidth, buyNowBorderActiveOn, addToCartBorderActiveOn, productInfo, variantColor, productVariantMap, selectedVariantSKU } = useContext(ProductModalContext)
    const { addToCart, removeFromCart, cartList } = useContext(AddToCartContext);
    const [isInWishlist, setIsInWishlist] = useState(false);
    const [firstSeenInWishlistButton, setFirstSeenInWishlistButton] = useState(false);

    useEffect(() => {
        const productSKU = selectedVariantSKU ? selectedVariantSKU : sku;
        if (cartList.find(item => item.SKU === productSKU)) {
            setIsInWishlist(true);
        } else {
            setIsInWishlist(false);
        }
    }, [cartList, selectedVariantSKU])


    const buyButtonClicked = () => {
        BuyNowOnce();
        BuyNowClicked(sku, title);
        window.open(url, '_blank');
    }

    const addToCartClicked = (option) => {
        const productSKU = selectedVariantSKU ? selectedVariantSKU : sku;

        if (isInWishlist && firstSeenInWishlistButton) {
            return;
        }

        if (isInWishlist) {
            removeFromCart(productSKU)
        } else {
            if(storeId === '620537bac38181ef4d34e618'){
                AddToWishlistTotalItems(cartList.length+1)
            }
            const priceCurrency = productVariantMap.siblings ? productVariantMap.siblings[productSKU].price_currency : productVariantMap.price_currency;
            const variantName = productVariantMap.siblings ? productVariantMap.siblings[productSKU].name : productVariantMap.name;
            const variantPrice = productVariantMap.siblings ? productVariantMap.siblings[productSKU].price : productVariantMap.price;
            const thumbnail = (productVariantMap.siblings && productVariantMap.siblings[productSKU].downsized_thumbnail) || downsizedThumbnail || productVariantMap.thumbnail;
            addToCart({
                SKU: productSKU,
                TITLE: variantName,
                DOWNSIZED_THUMBNAIL: thumbnail,
                PRICECURRENCY: priceCurrency,
                PRICE: variantPrice,
                COLOR: variantColor,
            });
            AddToWishlistClicked(productSKU, variantName)
            AddToWishlistValue(priceCurrency+variantPrice, variantName)
            setFirstSeenInWishlistButton(true);
        }
    }

    const renderCartText = () => {
        if (isInWishlist && firstSeenInWishlistButton) {
            return (
                <>
                    <div>{storeTrans[storeId]['removeButtonHeading1']}</div>
                    <div>{storeTrans[storeId]['removeButtonHeading2']}</div>
                </>
            );
        }
        if (isInWishlist) {
            return storeTrans[storeId]['removeButtonHeading3'];
        }
        return addToCartCopy;
    }

    return (
        <div className='product-button-container' style={{ width: addToCartEnabled && url ? '90%' : '70%' }}>
            {addToCartEnabled && <Button
                hoverStyleChange={true}
                onClick={addToCartClicked}
                primaryColor={isInWishlist ? colors && colors.addToCartSecondaryColor : colors && colors.addToCartPrimaryColor}
                secondaryColor={colors && colors.addToCartSecondaryColor}
                className="product-button flex-center obsessvr-regularFont full-width pointer"
                style={{ padding: '0', margin: '0 1%', borderRadius: '4px' }}
                primaryBorderWidth={addToCartBorderActiveOn && addToCartBorderActiveOn.primary ? buttonBorderWidth : undefined}
                secondaryBorderWidth={addToCartBorderActiveOn && addToCartBorderActiveOn.secondary ? buttonBorderWidth : undefined}
                primaryBorderColor={colors && colors.addToCartBorderColor}
                secondaryBorderColor={colors && colors.addToCartBorderColor}
                insetBorder={true}
                padded={false}
            >
                <p className='obsessvr-regularFont' style={addToCartFontStyle}>
                    {renderCartText()}
                </p>
            </Button>}
            {url && <Button
                hoverStyleChange={true}
                onClick={buyButtonClicked}
                primaryColor={colors && colors.buyNowPrimaryColor}
                secondaryColor={colors && colors.buyNowSecondaryColor}
                className="product-button flex-center obsessvr-regularFont full-width pointer"
                style={{ padding: '0', margin: '0 1%', borderRadius: '4px' }}
                primaryBorderWidth={buyNowBorderActiveOn && buyNowBorderActiveOn.primary ? buttonBorderWidth : undefined}
                secondaryBorderWidth={buyNowBorderActiveOn && buyNowBorderActiveOn.secondary ? buttonBorderWidth : undefined}
                primaryBorderColor={colors && colors.buyNowBorderColor}
                secondaryBorderColor={colors && colors.buyNowBorderColor}
                insetBorder={true}
                padded={false}
            >
                <p className='obsessvr-regularFont' style={buttonFontStyle}>
                    {productButtonCopy}
                </p>
            </Button>}
        </div>
    )
}

export default ProductModalButtons;